
export const chineseNumbers = [
    "一",
];

export const closePage = () => {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        WeixinJSBridge.call("closeWindow");
    } else {
        window.close();
    }
}




// WEBPACK FOOTER //
// ./src/utils/tool.js